import { TmBaseComponent } from '@treasury/presentation';
import { checkmarkIcon } from '@treasury/presentation/assets/icons';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

export const tagName = 'select-from-list';
@customElement(tagName)
export class SelectFromList<T> extends TmBaseComponent {
    @property()
    public list: T[] = [];

    @property()
    public selectedItem?: T;

    @property()
    public changeItem?: (item: T) => void;

    @property()
    public getDisplayNameFromListItem?: (item: T) => string;

    @property()
    public getIdFromListItem?: (item: T) => string;

    public render() {
        return html`<div class="bg-primary">${this.renderList()}</div>`;
    }

    private itemClickHandler(newItem: T) {
        if (this.changeItem) {
            this.changeItem(newItem);
        }
    }

    private renderIcon(item: T) {
        let isSelected;
        if (this.getIdFromListItem && this.selectedItem) {
            isSelected = this.getIdFromListItem(item) === this.getIdFromListItem(this.selectedItem);
        } else {
            isSelected = item === this.selectedItem;
        }

        return isSelected ? html`<tm-icon .icon=${checkmarkIcon}></tm-icon>` : nothing;
    }

    private renderList() {
        return this.list.map((item: T, idx) => {
            const clickHandler = () => this.itemClickHandler(item);
            const icon = this.renderIcon(item);

            const classes = classMap({
                'flex items-center h-full w-full text-sm': true,
                'border-b': idx !== this.list.length - 1,
            });
            return html`<button
                class="w-full h-12 flex items-center item-to-select"
                @click=${() => {
                    clickHandler();
                    this.dispatchEvent(
                        new CustomEvent('close', {
                            bubbles: true,
                        })
                    );
                }}
            >
                <div class="size-12 flex items-center justify-center">${icon}</div>
                <div class=${classes}>
                    ${this.getDisplayNameFromListItem
                        ? this.getDisplayNameFromListItem(item)
                        : item}
                </div>
            </button> `;
        });
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: SelectFromList<unknown>;
    }
}
